import { all } from "axios";
import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";
import RoleService from "./RoleService";

export default class AgendamentoService {
    async listAllAgendamentos(iss, dataInicio, dataFim) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('agendamento');
        const idPrestador = RoleService.getPrestador();

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllAgendamento(iss, dataInicio, dataFim, true);
            case 'COMPANY':
                return this.listAllAgendamento(iss, dataInicio, dataFim, false);
            case 'SELF':
                return this.listAllAgendamentoByPrestador(iss, idPrestador, dataInicio, dataFim);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    /// AGENDAMENTO ///
    listAllAgendamento(data, dataInicio, dataFim, allStatus) {
        var params = {
            dataInicio: dataInicio,
            dataFim: dataFim,
            allStatus: allStatus
        }

        return axiosInstance.get(`${config.api.version}/agendamento/${data}/get`, {
            params: params
        })
    }

    listAllAgendamentoByPrestador(data, prestadorId, dataInicio, dataFim) {
        return axiosInstance.get(`${config.api.version}/agendamento/${data}/get?prestadorTipoAgendamento.prestador.user.id=${prestadorId}&join=true&dataInicio=${dataInicio}&dataFim=${dataFim}`)
    }

    getAgendamento(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/agendamento/${data}/get/${id}`, {
            params: params
        })
    }

    getAgendamentoFilter(data, prestadorId, dataInicio, dataFim) {
        var params = {
            dataInicio: dataInicio,
            dataFim: dataFim
        }

        if (prestadorId)
            return axiosInstance.get(`${config.api.version}/agendamento/${data}/get?prestadorTipoAgendamento.prestador.user.id=${prestadorId}&join=true&dataInicio=${dataInicio}&dataFim=${dataFim}`)

        return axiosInstance.get(`${config.api.version}/agendamento/${data}/get`, {
            params: params
        })
    }

    postAgendamento(data, agendamento) {
        return axiosInstance.post(`${config.api.version}/agendamento/${data}/`, agendamento)
    }

    putAgendamento(data, agendamento, id) {
        return axiosInstance.put(`${config.api.version}/agendamento/${data}/${id}`, agendamento)
    }

    changeStatus(data, id, status) {
        return axiosInstance.put(`${config.api.version}/agendamento/${data}/status/${id}/${status}`)
    }

    deleteAgendamento(data, id) {
        return axiosInstance.delete(`${config.api.version}/agendamento/${data}/${id}`)
    }
}